module.exports = __webpack_public_path__ + "img/devices.730e5496.svg";